module.exports = __webpack_public_path__ + "img/U1F4A9.4ea8caf7.png";